'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const Newsletter: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="info-page">
            <Helmet>
                <title>{t('seo.newsletter.title')}</title>
                <meta name="description" content={t('seo.newsletter.description')} />
            </Helmet>
            <div className="container">
                <div className="info-card">
                    <h1>{t('seo.newsletter.title')}</h1>
                    <p>{t('seo.newsletter.description')}</p>
                </div>
            </div>
        </div>
    );
};
